import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-orders-qinetic-error-dialog',
  templateUrl: './orders-qinetic-error-dialog.component.html',
  styleUrls: ['./orders-qinetic-error-dialog.component.scss'],
})
export class OrdersQineticErrorDialogComponent {
  position_error?: { code: string; description: string; message: string };

  constructor(private dialog_ref: MatDialogRef<OrdersQineticErrorDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    this.position_error = data.position_error;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }
}
